import { AxiosPromise } from 'axios';
import { UserInfo } from '../../types/UserConfig';
import { libApiInstance } from '../axios';
import { RequestImpersonate } from './types/Support';

export function requestClientUsers(
    clientId: number | undefined,
    signal?: AbortSignal,
): AxiosPromise<UserInfo[]> {
    return libApiInstance.get(`/support/clientUsers/${clientId}`, {
        signal,
    });
}

export function requestImpersonate(
    payload: RequestImpersonate,
    signal?: AbortSignal,
): AxiosPromise {
    return libApiInstance.post(`/support/impersonate/`, payload, {
        signal,
    });
}

export function requestStopImpersonating(signal?: AbortSignal): AxiosPromise {
    return libApiInstance.post(`/support/stopImpersonating/`, {
        signal,
    });
}
